export const WORK_ORDER_CONTAINER_STATUS = {
  ACTIVE: 'ACTIVE',
  DISABLED: 'DISABLED',
} as const

export type WorkOrderContainerStatus = typeof WORK_ORDER_CONTAINER_STATUS[keyof typeof WORK_ORDER_CONTAINER_STATUS]

/**
 * A container is "disabled" for a work order when it belongs to the service but isn't assigned
 * to this WO. WorkOrderContainersSection derives that from the service-vs-WO diff and stamps
 * `workOrderContainerStatus`; DISABLED renders as "Removed from WO", missing/ACTIVE renders normally.
 */
export const isContainerDisabledForWorkOrder = (container?: { workOrderContainerStatus?: WorkOrderContainerStatus | null }): boolean =>
  container?.workOrderContainerStatus === WORK_ORDER_CONTAINER_STATUS.DISABLED
